import { Decimal } from "decimal.js/decimal.mjs"

/**
 * 加法
 * @param {*} a 数字a
 * @param {*} b 数字b
 * @return Decimal.js加法运算 a + b
 */
function add(a, b) {
  const c = new Decimal(a).add(new Decimal(b)).toNumber()
  return c
}

/**
 * 减法
 * @param {*} a 数字a
 * @param {*} b 数字b
 * @return Decimal.js加法运算 a - b
 */
function sub(a, b) {
  const c = new Decimal(a).sub(new Decimal(b)).toNumber()
  return c
}

/**
 * 乘法
 * @param {*} a 数字a
 * @param {*} b 数字b
 * @return Decimal.js加法运算 a * b
 */
function mul(a, b) {
  const c = new Decimal(a).mul(new Decimal(b)).toNumber()
  return c
}

/**
 * 除法
 * @param {*} a 数字a
 * @param {*} b 数字b
 * @return Decimal.js加法运算 a / b
 */
function div(a, b) {
  const c = new Decimal(a).div(new Decimal(b)).toNumber()
  return c
}

export default {
  add,
  sub,
  mul,
  div
}
